export default __webpack_public_path__ + "static/media/p-1.f8fb9edc.png";